import apiClient from "api";
import type { User, UpdateUserData } from "@/types";

export const userService = {
  async getUserMe(): Promise<User> {
    const response = await apiClient.get("/entities/users/me");
    return response.data;
  },

  async updateUserMe(userData: UpdateUserData): Promise<User> {
    const response = await apiClient.patch("/entities/users/me", userData);
    return response.data;
  },
};
